var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.legalNoticeLg.lg1.length > 0)?_c('div',{staticClass:"d-flex flex-column justify-content-around align-items-left",attrs:{"id":"legalNotice"},domProps:{"innerHTML":_vm._s(_vm.rawHtml(_vm.legalNoticeLg[_vm.currentLg]))}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7b0e21e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ibis/rates/horizontal/v1/services/legalNoticeCenter.vue
// module id = ZyQq
// module chunks = 0